/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   Generic Meta selectors
 */

/**
 * @template T
 * @param {{currentKey: T}} state
 * @returns {T}
 */
export const selectCurrentKey = (state) => state.currentKey

/**
 * @template T
 * @param {{error: T}} state
 * @returns {T}
 */
export const selectError = (state) => state.error

/**
 * @template T
 * @param {{fetching: T}} state
 * @returns {T}
 */
export const selectFetching = (state) => state.fetching

/**
 * @template T
 * @param {{fetchingKey: T}} state
 * @returns {T}
 */
export const selectFetchingKey = (state) => state.fetchingKey
